import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import styles from './DiscountOffer.module.css';
import { 
    HeroSection,
    FeaturesSection,
    ResultsSection,
    CancelSection
} from './components';
import { applyDiscount } from '../../services/paymentService';
import { fetchUserByToken } from '../../app/features/userSlice';

function DiscountOffer() {
    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if(user?.discountApplied) {
            navigate('/questionnaire');
        }
        // console.log(user?.discountApplied);
    }, [user?.discountApplied]);
    const handleAvailDiscount = (discountPercentage = '30%') => {
        setLoading(true);
        applyDiscount(user.subscriptionDetail.id, discountPercentage, user.id)
            .then((response) => {
                
                if (response === `${discountPercentage} discount applied successfully to your next billing cycle!`) {
                    toast.success(response);
                    dispatch(fetchUserByToken(userToken));
                    navigate('/profile/billing');
                } else if (response === "Discount has already been applied to this account.") {
                    toast.error(t('subscription.discount_already_applied'));
                } else {
                    toast.error(response);
                }
            })
            .catch(error => {
                 if (error === "Discount has already been applied to this account.") {
                    toast.error(t('subscription.discount_already_applied'));
                } else {
                    toast.error(error.message || t('general.UI.something_went_wrong'));
                }
                })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleProceedToCancel = () => {
        setLoading(true);
        // Navigate to the cancellation page or process
        setTimeout(() => {
            setLoading(false);
        navigate('/questionnaire');
        // navigate('/profile/billing');
        }, 1000);
    };

    return (
        <div className={styles.discountOfferPage}>
            <Helmet>
                <title>{t('subscription.discount_page_title')}</title>
            </Helmet>
            <i className={styles.circle1}/>
            <i className={styles.circle2}/>
            <i className={styles.circle3}/>
            <i className={styles.circle4}/>

            <HeroSection 
                onAvailDiscount={() => handleAvailDiscount('30%')} 
                loading={loading}
                discountApplied={user?.discountApplied} 
            />
            
            <FeaturesSection />
            
            <ResultsSection />
            
            <CancelSection 
                onProceedToCancel={handleProceedToCancel} 
                loading={loading} 
            />
        </div>
    );
}

export default DiscountOffer; 